export default "__VITE_ASSET__CbTzgw3S__"